import * as brokerApplicationActions from './brokerApplicationReducer';
import Axios from 'axios';
import { push } from 'react-router-redux';
import queryString from '../../../helpers/queryString';
import handleErrorResponse from '../../../helpers/handleErrorResponse';
import { set } from 'lodash';
import request from 'axios/index';

export const defaultIncludes = [];
// export const defaultIncludes = ['parent', 'principal', 'organisation_type', 'legal_entity_type', 'users', 'primary_contacts', 'accounts_contacts', 'network.standard_commission', 'insurers.authorised_users']

// + '?include=brokers,channels'
const getBrokerApplication = (id, includes = defaultIncludes) => {
  return (dispatch) => {
    let endpoint =
      '/brokers/applications/' +
      id +
      '?include=organisation,networks,broker_region,broker_category,legal_entity_type';
    endpoint += queryString(includes);

    return Axios.get(endpoint).then((response) => {
      dispatch({
        type: brokerApplicationActions.SET_BROKER_APPLICATION,
        data: response.data,
      });
      return true;
    });
  };
};

const getBrokerMessage = (id) => {
  return (dispatch) => {
    const endpoint = '/brokers/contacts/' + id;

    return Axios.get(endpoint).then((response) => {
      dispatch({
        type: brokerApplicationActions.SET_BROKER_MESSAGE,
        data: response.data,
      });
      return true;
    });
  };
};

const createBrokerApplication = (resource, redirect = false) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post('brokers/applications', resource)
      .then((response) => {
        dispatch(isSubmitting(false));
        if (redirect) {
          dispatch(push('/admin/broker-applications/?include=legal_entity_type'));
        }

        return response.data;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'There was an error creating the broker application');
      });
  };
};

const getProductInsurers = () => {
  return (dispatch) => {
    return Axios.get('/product-insurers').then((response) => {
      dispatch({
        type: brokerApplicationActions.SET_PRODUCT_INSURERS,
        data: response.data.meta,
      });
      return true;
    });
  };
};

const updateBrokerApplication = (resource, includes = defaultIncludes) => {
  return (dispatch) => {
    //
    // const enabledBrokerCommissions = resource.data.attributes.broker_commission?.filter((commission) => {
    //   return !!commission?.rates.find((rate) => rate.enabled);
    // });
    // set(resource, 'data.attributes.broker_commission', enabledBrokerCommissions);
    dispatch(isSubmitting(true));
    const id = resource.data.id;
    let endpoint = '/brokers/applications/' + id + '/?include=legal_entity_type';
    endpoint += queryString(includes);
    return Axios.patch(endpoint, resource)
      .then((response) => {
        dispatch({
          type: brokerApplicationActions.SET_BROKER_APPLICATION,
          data: response.data,
        });
        dispatch(isSubmitting(false));
        return response.data;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'There was an error updating the broker application');
      });
  };
};

const declineBrokerApplication = (resource) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    const id = resource.data.id;
    let endpoint = '/brokers/applications/' + id + ':decline';

    return Axios.post(endpoint, resource)
      .then(() => {
        // dispatch({
        //   type: actions.SET_BROKER_APPLICATION,
        //   data: response.data
        // })
        dispatch(isSubmitting(false));
        dispatch(push('/admin/broker-applications/'));
        return true;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'There was an error updating the broker application');
      });
  };
};

const approveBrokerApplication = (resource) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    const id = resource.data.id;
    let endpoint = '/brokers/applications/' + id + ':approve';

    if (resource) {
      set(resource, 'meta.send_email', true);
    }

    return Axios.post(endpoint, resource)
      .then(() => {
        dispatch(isSubmitting(false));
        dispatch(push('/admin/broker-applications/'));
        return true;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'There was an error updating the broker application');
      });
  };
};

const resendBrokerApplication = (resource) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    const id = resource.data.id;
    let endpoint = '/brokers/applications/' + id + ':send-approval-email';

    return Axios.post(endpoint, resource)
      .then(() => {
        // dispatch({
        //   type: actions.SET_BROKER_APPLICATION,
        //   data: response.data
        // })
        dispatch(isSubmitting(false));
        //dispatch(push('/admin/broker-applications/'));
        return true;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'There was an error updating the broker application');
      });
  };
};

export function saveAndApproveBrokerApplication(resource) {
  return (dispatch) => {
    //we need to filter out any products without commission set to prevent user getting assigned to products
    // const enabledBrokerCommissions = resource.data.attributes.broker_commission?.filter((commission) => {
    //   return !!commission?.rates.find((rate) => rate.enabled);
    // });
    // set(resource, 'data.attributes.broker_commission', enabledBrokerCommissions);

    if (resource.data.id) {
      return dispatch(updateBrokerApplication(resource)).then(() => {
        return dispatch(approveBrokerApplication(resource));
      });
    } else {
      return dispatch(createBrokerApplication(resource)).then((response) => {
        return dispatch(approveBrokerApplication(response));
      });
    }
  };
}

const isSubmitting = (status) => {
  return {
    type: brokerApplicationActions.IS_SUBMITTING,
    status,
  };
};

const isFetching = (status) => {
  return {
    type: brokerApplicationActions.IS_FETCHING,
    status,
  };
};

const getOrganisationByFCANumber = (fcaNumber) => {
  let urlOrg =
    'organisations?filter[regulatory_authority_number]=' +
    fcaNumber +
    '&include=legal_entity_type';
  return (dispatch) => {
    dispatch(isFetching(true));
    return request
      .get(urlOrg)
      .then((response) => {
        if (response.data.data.length === 1) {
          dispatch({
            type: brokerApplicationActions.SET_EXISTING_PARENT_ORGANISATION,
            data: response.data.data[0],
          });
        } else {
          dispatch(clearExistingOrganisation());
        }
        dispatch(isFetching(false));
      })
      .catch(() => {
        dispatch(isFetching(false));
      });
  };
};

const getOrganisationById = (id) => {
  let urlOrg = 'organisations/' + id + '?include=legal_entity_type';
  return (dispatch) => {
    dispatch(isFetching(true));
    return request
      .get(urlOrg)
      .then((response) => {
        if (response.data.data) {
          dispatch({
            type: brokerApplicationActions.SET_EXISTING_PARENT_ORGANISATION,
            data: response.data.data,
          });
        } else {
          dispatch(clearExistingOrganisation());
        }
        dispatch(isFetching(false));
      })
      .catch(() => {
        dispatch(isFetching(false));
      });
  };
};

const clearExistingOrganisation = () => {
  return {
    type: brokerApplicationActions.SET_EXISTING_PARENT_ORGANISATION,
    data: null,
  };
};

export const actions = {
  getBrokerApplication,
  getBrokerMessage,
  createBrokerApplication,
  updateBrokerApplication,
  declineBrokerApplication,
  //approveBrokerApplication,
  resendBrokerApplication,
  isSubmitting,
  isFetching,
  getOrganisationByFCANumber,
  clearExistingOrganisation,
  saveAndApproveBrokerApplication,
  getOrganisationById,
  getProductInsurers,
};
